'use strict';exports.__esModule = true;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _ramda = require('ramda');
var _reactRedux = require('react-redux');
var _reduxPagan = require('redux-pagan');
var _reduxForm = require('redux-form');
var _reactRouter = require('react-router');
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);

var _components = require('../../components');




var _editCompanyByOwner = require('../../redux/modules/editCompanyByOwner');




var _messageModal = require('../../redux/modules/messageModal');

var _helpers = require('./helpers');
var _appendLocale = require('../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);
var _checkRtlLanguage = require('../../utils/checkRtlLanguage');var _checkRtlLanguage2 = _interopRequireDefault(_checkRtlLanguage);
var _professionals = require('../../redux/modules/professionals');



var _EditCompanyByOwner = require('./EditCompanyByOwner.scss');var _EditCompanyByOwner2 = _interopRequireDefault(_EditCompanyByOwner);
var _userAuthentication = require('../../redux/modules/userAuthentication');
var _formatPhoneNumber = require('../../utils/formatPhoneNumber');
var _assetsToDelete = require('../../redux/modules/assetsToDelete');




var _placesGeocode = require('../../redux/modules/placesGeocode');
var _reportIssues = require('../../redux/modules/reportIssues');
var _succsessPublish = require('../../../static/icons/succsessPublish.svg');var _succsessPublish2 = _interopRequireDefault(_succsessPublish);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Components
// Helpers
var selector = (0, _reduxForm.formValueSelector)('editCompanyByOwnerForm');var changeValue = function changeValue(name, value) {return (0, _reduxForm.change)('editCompanyByOwnerForm', name, value);};

var defaultMessage = {
  he: 'רוצה להפעיל עמוד חברה',
  en: 'I want to activate the company page',
  ru: 'Хочу активировать страницу компании',
  fr: 'Je souhaite activer la page entreprise' };var


EditCompanyByOwner = function (_Component) {_inherits(EditCompanyByOwner, _Component);function EditCompanyByOwner() {var _temp, _this, _ret;_classCallCheck(this, EditCompanyByOwner);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    state = {
      captcha: null,
      phoneNumber: '',
      countryCode: '',
      phoneNumberIsInvalid: false }, _this.





























































    addAssetToDelete = function (_ref) {var publicId = _ref.publicId,contentType = _ref.contentType;
      _this.props.addAssetToDelete({ id: publicId, type: contentType });
    }, _this.

    showErrorMessage = function (message) {return _this.props.openMessageModal({
        message:
        _react2.default.createElement('div', null,
          _react2.default.createElement('p', null, message),
          _react2.default.createElement('button', { className: 'btn btn-primary', onClick: _this.closeMessage },
            _this.props.translate('contactUsPage', 'ok'))),



        messageModalClassName: 'company-message-modal',
        isCloseButtonInvisible: true });}, _this.


    showSuccessMessage = function (isNewCompany) {
      var successMessage = isNewCompany ? 'creating_success' : 'submitting_success';

      _this.props.openMessageModal({
        message:
        _react2.default.createElement('div', { className: _EditCompanyByOwner2.default.successModal },
          _react2.default.createElement('p', { className: _EditCompanyByOwner2.default.title },
            _this.props.translate('editOwner', successMessage)),

          _react2.default.createElement('img', { width: '257', height: '234', className: _EditCompanyByOwner2.default.image, src: _succsessPublish2.default, alt: '' }),
          isNewCompany && _react2.default.createElement('p', { className: _EditCompanyByOwner2.default.subtitle }, _this.props.translate('editOwner', 'warnMessage')),
          _react2.default.createElement('button', { className: 'btn btn-primary', onClick: _this.closeMessage },
            _this.props.translate('contactUsPage', 'ok'))),



        additionalClassName: 'createCompanySuccessModal',
        isCloseButtonInvisible: true });

    }, _this.

    closeMessage = function (evt) {
      evt.preventDefault();
      _this.props.hideMessageModal();
    }, _this.

    handlePhoneChange = function (evt) {var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';var flag = arguments[2];
      var normalizedValue = value.replace(/\s/g, '');

      if (_this.state.countryCode === '') {
        return _this.setState(function (state) {return Object.assign({},
          state, {
            countryCode: '+' + flag.dialCode });});

      }

      _this.setState({ phoneNumber: normalizedValue });

      if ('+' + flag.dialCode !== _this.state.countryCode) {
        _this.setState({ countryCode: '+' + flag.dialCode });
      }

      return _this.props.changeValue('phone_number', '+' + flag.dialCode + normalizedValue);
    }, _this.

    validatePhoneNumber = function () {var phoneNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var number = phoneNumber.toString().replace(/\D/g, '');
      var isValid = !!number && number.length >= 9 && number.length <= 15;

      _this.setState({ phoneNumberIsInvalid: !isValid });
      return !isValid;
    }, _this.

    closeContactUsFormModal = function () {
      document.body.style.overflow = '';
      _this.props.closeProfessionalsContactModal();
    }, _this.

    sendEmailNotificationToAdmin = function (values) {
      _this.props.sendProfessionalsContactUsForm({
        name: (0, _get2.default)(values, 'name.he', '-'),
        phone: (0, _formatPhoneNumber.clearPhoneNumber)((0, _get2.default)(values, 'phone_number', '-')),
        type: (0, _get2.default)(values, 'type'),
        message: 'User with id - "' + (0, _get2.default)(values, 'owner_id') + '" has created a company page with id - "' + (0, _get2.default)(values, 'id') + '".',
        city: values.branches.map(function (b) {return b.address.en.city_name;}).join(', '),
        isCompanyByOwner: true });

    }, _this.

    fetchReCaptchaToken = function (token) {return _this.setState({ captcha: token });}, _this.

    contactUsFormSubmitHandler = function (formValues) {var
      captcha = _this.state.captcha;

      _this.props.sendProfessionalsContactUsForm(Object.assign({
        captcha: captcha },
      formValues));

      _this.setState({ captcha: null });
    }, _this.

    goCompany = function () {return _reactRouter.browserHistory.push((0, _appendLocale2.default)(_this.props.locale, '/company/' + (0, _get2.default)(_this.props, 'userData.data.agent_data.agency_id')));}, _temp), _possibleConstructorReturn(_this, _ret);}EditCompanyByOwner.prototype.componentDidMount = function componentDidMount() {var companyId = (0, _get2.default)(this.props, 'userData.data.agent_data.agency_id');var access_token = (0, _get2.default)(this.props, 'userData.data.access_token');if (companyId) {this.props.loadCompany({ id: companyId, access_token: access_token });}};EditCompanyByOwner.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {var editCompanyByOwnerSubmitting = nextProps.editCompanyByOwnerSubmitting,editCompanyByOwnerSubmitted = nextProps.editCompanyByOwnerSubmitted,editCompanyByOwnerError = nextProps.editCompanyByOwnerError,isMessageModalOpen = nextProps.isMessageModalOpen,initialValues = nextProps.initialValues;var companyWasCreated = (0, _get2.default)(initialValues, 'id') && !(0, _get2.default)(this.props, 'initialValues.id');var pageIsNotActivated = (0, _get2.default)(initialValues, 'id') && !((0, _get2.default)(initialValues, 'page.enabled') && (0, _get2.default)(initialValues, 'page.until'));var phoneNumber = (0, _get2.default)(initialValues, 'phone_number');if (!(0, _get2.default)(this.props, 'initialValues.phone_number') && phoneNumber) {this.setState({ phoneNumber: phoneNumber });}if (this.props.editCompanyByOwnerSubmitting && !editCompanyByOwnerSubmitting) {if (editCompanyByOwnerSubmitted && !this.props.editCompanyByOwnerSubmitted && !editCompanyByOwnerError) {var isNewCompany = !(0, _get2.default)(this.props, 'userData.data.agent_data.agency_id');this.showSuccessMessage(isNewCompany);if (pageIsNotActivated) {this.sendEmailNotificationToAdmin(initialValues);}this.props.changeAssetsTags();}if (!editCompanyByOwnerSubmitted && editCompanyByOwnerError) {this.showErrorMessage(this.props.translate('editOwner', 'errorMessage'));}}if (companyWasCreated && !(0, _get2.default)(this.props, 'userData.data.agent_data.agency_id')) {this.props.authUserByToken((0, _get2.default)(this.props, 'userData.data.access_token'));}if (!isMessageModalOpen && editCompanyByOwnerSubmitted && this.props.isMessageModalOpen) {this.goCompany();}};EditCompanyByOwner.prototype.componentWillUnmount = function componentWillUnmount() {this.props.resetForm();this.props.cleanAssets();};EditCompanyByOwner.prototype.

  render = function render() {
    var loadingError = !!(0, _get2.default)(this.props, 'loadingError.status');
    var disableCompanyForm = loadingError;

    return (
      _react2.default.createElement('div', { className: _EditCompanyByOwner2.default.wrapper },
        _react2.default.createElement(_components.EditCompanyByOwnerForm, _extends({},
        this.props, {
          addAssetToDelete: this.addAssetToDelete,
          disableCompanyForm: disableCompanyForm,
          fetchReCaptchaToken: this.fetchReCaptchaToken,
          formSubmitted: this.props.professionalContactFormSubmitted,
          captchaIdentifier: 'edit_company',
          captcha: this.state.captcha,
          onPhoneChange: this.handlePhoneChange,
          phoneNumber: this.state.phoneNumber,
          validatePhoneNumber: this.validatePhoneNumber,
          phoneNumberIsInvalid: this.state.phoneNumberIsInvalid,
          countryCode: this.state.countryCode })),

        disableCompanyForm &&
        _react2.default.createElement('section', null,
          _react2.default.createElement(_components.ProfessionalContactUs, {
            fetchReCaptchaToken: this.fetchReCaptchaToken,
            translate: this.props.translate,
            onSubmit: this.contactUsFormSubmitHandler,
            isRtl: this.props.isRtl,
            formSubmitting: this.props.professionalContactFormSubmitting,
            formSubmitted: this.props.professionalContactFormSubmitted,
            formError: this.props.professionalContactFormError,
            showMessage: this.props.openMessageModal,
            closeModal: this.closeContactUsFormModal,
            withoutOverflow: !this.props.isMobile,
            initialValues: { message: defaultMessage[this.props.locale] },
            captchaIdentifier: 'editCompany' }))));





  };return EditCompanyByOwner;}(_react.Component);


EditCompanyByOwner.propTypes = {
  isRtl: _propTypes2.default.bool,
  isMobile: _propTypes2.default.bool,
  locale: _propTypes2.default.string,
  fields: _propTypes2.default.object,
  resetForm: _propTypes2.default.func,
  userData: _propTypes2.default.object,
  initialValues: _propTypes2.default.object,
  loadingError: _propTypes2.default.object,
  translate: _propTypes2.default.func.isRequired,
  editCompanyByOwnerSubmitted: _propTypes2.default.bool,
  editCompanyByOwnerSubmitting: _propTypes2.default.bool,
  editCompanyByOwnerError: _propTypes2.default.object,
  isMessageModalOpen: _propTypes2.default.bool,
  openMessageModal: _propTypes2.default.func,
  hideMessageModal: _propTypes2.default.func,
  changeAssetsTags: _propTypes2.default.func,
  cleanAssets: _propTypes2.default.func,
  addAssetToDelete: _propTypes2.default.func,
  addAssetToUnsuspend: _propTypes2.default.func,
  loadCompany: _propTypes2.default.func,
  authUserByToken: _propTypes2.default.func,
  createCompanyByOwner: _propTypes2.default.func,
  sendEditCompanyByOwnerForm: _propTypes2.default.func,
  professionalContactFormSubmitted: _propTypes2.default.bool,
  professionalContactFormSubmitting: _propTypes2.default.bool,
  professionalContactFormError: _propTypes2.default.object,
  professionalContactFormIsOpen: _propTypes2.default.bool,
  openProfessionalsContactModal: _propTypes2.default.func,
  closeProfessionalsContactModal: _propTypes2.default.func,
  sendProfessionalsContactUsForm: _propTypes2.default.func,
  receiveGeocodedPlace: _propTypes2.default.func,
  openReportIssueModal: _propTypes2.default.func,
  changeValue: _propTypes2.default.func,
  geocodedPlace: _propTypes2.default.object,
  geocodeFailed: _propTypes2.default.bool,
  isAgent: _propTypes2.default.bool };


var mapStateToProps = function mapStateToProps(store) {return {
    isRtl: (0, _checkRtlLanguage2.default)(store.lang.locale),
    locale: store.lang.locale,
    translate: (0, _reduxPagan.getLang)(store.lang, 'static'),
    fields: {
      type: selector(store, 'type'),
      images: selector(store, 'images'),
      image: selector(store, 'image'),
      name_he: selector(store, 'name.he'),
      description_he: selector(store, 'description.he'),
      additional_info_he: selector(store, 'additional_info.he'),
      branches: selector(store, 'branches'),
      address: selector(store, 'address'),
      phone_number: selector(store, 'phone_number') },

    isMessageModalOpen: store.messageModal.isMessageModalOpen,
    userData: store.userAuthentication,
    isMobile: store.windowDimentions.isMobile,
    initialValues: (0, _helpers.formatCompanyInitialValues)(store.editCompanyByOwner.data, store.lang.locale),
    loadingError: store.editCompanyByOwner.error,
    editCompanyByOwnerError: store.editCompanyByOwner.formError,
    editCompanyByOwnerSubmitted: store.editCompanyByOwner.submitted,
    loading: store.editCompanyByOwner.loading,
    editCompanyByOwnerSubmitting: store.editCompanyByOwner.submitting,
    professionalContactFormSubmitted: store.professionals.formSubmitted,
    professionalContactFormSubmitting: store.professionals.formSubmitting,
    professionalContactFormError: store.professionals.formError,
    professionalContactFormIsOpen: store.professionals.professionalContactFormIsOpen,
    geocodeFailed: !!store.placesGeocode.error || store.placesGeocode.geocodedPlace === null,
    geocodedPlace: store.placesGeocode.geocodedPlace,
    isAgent: store.userAuthentication.data ? (0, _get2.default)(store.userAuthentication, 'data.is_agent') : selector(store, 'customerType') === 'agent' };};



var mapDispatchToProps = {
  createCompanyByOwner: _editCompanyByOwner.createCompanyByOwner,
  sendEditCompanyByOwnerForm: _editCompanyByOwner.sendEditCompanyByOwnerForm,
  loadCompany: _editCompanyByOwner.loadCompany,
  openMessageModal: _messageModal.openMessageModal,
  hideMessageModal: _messageModal.hideMessageModal,
  authUserByToken: _userAuthentication.authUserByToken,
  resetForm: _editCompanyByOwner.reset,
  changeAssetsTags: _assetsToDelete.changeAssetsTags,
  cleanAssets: _assetsToDelete.cleanAssets,
  addAssetToDelete: _assetsToDelete.addAssetToDelete,
  addAssetToUnsuspend: _assetsToDelete.addAssetToUnsuspend,
  openProfessionalsContactModal: _professionals.openProfessionalsContactModal,
  closeProfessionalsContactModal: _professionals.closeProfessionalsContactModal,
  sendProfessionalsContactUsForm: _professionals.sendProfessionalsContactUsForm,
  receiveGeocodedPlace: _placesGeocode.receiveGeocodedPlace,
  openReportIssueModal: _reportIssues.openReportIssueModal,
  changeValue: changeValue };exports.default =


(0, _ramda.compose)(
(0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps))(
EditCompanyByOwner);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/EditCompanyByOwner/EditCompanyByOwner.js
// module id = 2982
// module chunks = 0